var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.item.itemDetails
      ? _c(
          "div",
          { staticClass: "pt-5 pb-5" },
          [
            _c("div", { staticClass: "pt-4" }),
            _c(
              "v-tabs",
              {
                attrs: { "active-class": "tabActive" },
                model: {
                  value: _vm.tabs,
                  callback: function ($$v) {
                    _vm.tabs = $$v
                  },
                  expression: "tabs",
                },
              },
              [
                _c("v-tabs-slider", { attrs: { color: "white" } }),
                _c("v-tab", { key: 0 }, [_vm._v(" Beschreibung ")]),
                _c("v-tab", { key: 1 }, [_vm._v(" Details ")]),
              ],
              1
            ),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tabs,
                  callback: function ($$v) {
                    _vm.tabs = $$v
                  },
                  expression: "tabs",
                },
              },
              [
                _c("v-tab-item", { key: 0, attrs: { ripple: false } }, [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.item.descriptionDE) },
                  }),
                ]),
                _c("v-tab-item", { key: 1, attrs: { ripple: false } }, [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.item.itemDetails) },
                  }),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }